export default __webpack_public_path__ + "b24c65acacd76683ad7b6981aeb8f3d6.jpeg";